module.exports = __webpack_public_path__ + "static/media/app_login_logo.217e20b4.png";